export const BRAND_TYPES = {
  MASTER: 'MASTER',
  OWNED: 'OWNED',
}

export const TARGET_MASTER_BRAND = {
  name: 'Target',
  slug: 'target',
}

export const MASTER_BRAND_CATEGORY = {
  code: 'master_brand',
  id: 'd1a28d0b-143e-48e5-9166-df7d889ac622',
  label: 'Master Brand',
  value: '',
}

export const BRAND_TYPE_OPTIONS = [
  {
    label: 'Owned Brand',
    value: BRAND_TYPES.OWNED,
  },
  {
    label: 'Target Master Brand',
    value: BRAND_TYPES.MASTER,
  },
]

export const BRAND_REASON_OPTIONS = [
  {
    id: 'first-run',
    label: 'Existing brand being added during First Run',
    value: 'Existing brand being added during First Run',
  },
  { id: 'new-launch', label: 'New brand launch', value: 'New brand launch' },
  {
    id: 'reactivated',
    label: 'Returning / reactivated brand',
    value: 'Returning / reactivated brand',
  },
  { id: 'other', label: 'Other', value: 'Other' },
]

export const CREATE_BRAND_STEPS = ['details', 'ownership', 'review']
